import React, { Fragment } from 'react';

export function GoalCreateWrapper() {
	return <Fragment></Fragment>;
}
